/** 店铺物料库存菜单（990360+；patch 103） */
export const STORE_MATERIAL_MENU_IDS = {
  group: 990360,
  stock: 990361,
  orders: 990362,
  consumable: 990363,
  mq: 990364,
  invoice: 990362
}



// WEBPACK FOOTER //
// ./src/constants/storeMaterial.js